<template>
    <v-flex xl12>
        <h2>Newsletters <span class="text-title-header"> | Mala direta CSV</span></h2>
        <v-divider></v-divider>
        <br/>
        <router-view></router-view>
    </v-flex>
</template>
<script>
export default {
  name: 'advertisers',
  mounted: function () {
    this.$nextTick(function () {

    })
  }
}
</script>
